import classNames from "classnames";
import {
  RESERVATION_RESERVATION,
  RESERVATION_TICKET,
  RESERVATION_VOYAGE,
  RESERVATION_INCIDENT,
  RESERVATION_RECLAMATION,
  RESERVATION_REMBOURSEMENT,
  RESERVATION_RECHERCHE,
} from "../../core/constants/layout";
import { useLayoutContext } from "../../core/context/layout-context";
import ReservationsConsole, { useReservationsStore } from "./components/reservations-console";
import RechercheReservation from "./components/recherche-reservation";
import ReclamationsConsole from "../../components/reclamations/reclamations-console";
import { RESERVATION_RECLAM_CONFIG } from "./components/reclamations-config";
import Contact from "./components/contact";
import TemplateCampagne from "./components/temlate-campagne";
import CreateTemplate from "./components/template-campagne/create-template";

export default function ReservationsPage() {
  const { selectChildren } = useLayoutContext();
  // Shared by the console and the search engine.
  const store = useReservationsStore();

  const ChildrenReservations = () => {
    switch (selectChildren) {
      case RESERVATION_RECHERCHE:
        return <RechercheReservation store={store} />;
      case RESERVATION_RESERVATION:
      case RESERVATION_TICKET:
        return <ReservationsConsole store={store} />;
      case RESERVATION_RECLAMATION:
        return <ReclamationsConsole config={RESERVATION_RECLAM_CONFIG} />;
      // Hidden from the menu (display: false), still reachable by URL.
      case RESERVATION_VOYAGE:
        return <Contact />;
      case RESERVATION_INCIDENT:
        return <TemplateCampagne />;
      case RESERVATION_REMBOURSEMENT:
        return <CreateTemplate />;
      default:
        return <ReservationsConsole store={store} />;
    }
  };

  return (
    <div className={classNames("pt-[50px] pb-6 min-h-screen bg-[#faf7ff] flex flex-col")}>
      <div className="flex-1 min-h-0 flex flex-col">{ChildrenReservations()}</div>
    </div>
  );
}
